import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import { useTheme } from "@mui/material/styles";
import MobileLoginForm from "../login/MobileLogin";
import MobileRegisterForm from "../register/MobileRegister";
import Logo from "../../assets/img/logo-og.png";
import Logo2 from "../../assets/img/media-one-logo.png";

import "../login/mobileLogin.css";
import "../register/mobileRegister.css";

const AuthTabs = () => {
  const theme = useTheme();
  const location = useLocation();

  // Set initial tab based on URL, so direct links to /mobile-register still work
  const [activeTab, setActiveTab] = useState(
    location.pathname === "/mobile-register" ? "register" : "login"
  );

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <div className="mobileLogin">
      <div className="mobileLogin-wrapper">
        <div className="mobileLogin-topSection">
          <div className="mobileLogin-top-wrapper">
            <div className="mobileLogin-logo-wrapper">
              <div className="mobileRegister-logo1"><img src={Logo2} alt="" /></div>
              <div className="mobileRegister-logo1"><img src={Logo} alt="" /></div>
            </div>
            <div className="mobileLogin-heading">
              <h3>FIFA 2026</h3>
              <h3>PREDICTION CONTEST</h3>
            </div>
          </div>
        </div>

        <div className="mobileLogin-bottomSection">
          <div className="mobileLogin-bottom-wrapper">
            <div className="mobileLogin-form-wrapper">
              <TabContext value={activeTab}>
  <Tabs
  value={activeTab}
  onChange={handleChange}
  TabIndicatorProps={{ style: { display: "none" } }}
  sx={{
    minHeight: "unset",
    backgroundColor: "#f1f2f6",
    borderRadius: "30px",
    padding: "4px",
    margin: "10px 20px 10px 20px",
    // no gap needed here — remove it if you added it
  }}
>
  <Tab
    label="LOGIN"
    value="login"
    sx={{
      flex: 1,
      borderRadius: "26px 0 0 26px",   // ← round LEFT side only
      minHeight: "40px",
      textTransform: "none",
       padding: "14px 0",
      fontFamily: "Manrope",
      fontWeight: 900,
      letterSpacing: "1px",
      color: "#8a8f98",
      backgroundColor: "#ffffff",
      "&.Mui-selected": {
        backgroundColor: "#0c1230",
        color: "#ffffff",
            transition: "background-color 0.4s ease, color 0.25s ease",   // ← ADD THIS

      },
    }}
  />
  <Tab
    label="REGISTER"
    value="register"
    sx={{
      flex: 1,
      borderRadius: "0 26px 26px 0",   // ← round RIGHT side only
      minHeight: "40px",
      textTransform: "none",
      fontFamily: "Manrope",
             padding: "14px 0",

      fontWeight: 900,
      letterSpacing: "1px",
      color: "#8a8f98",
          transition: "background-color 0.4s ease, color 0.25s ease",   // ← ADD THIS

      backgroundColor: "#ffffff",
      "&.Mui-selected": {
        backgroundColor: "#0c1230",
        color: "#ffffff",
      },
    }}
  />
</Tabs>

                <TabPanel value="login" dir={theme.direction}>
                  <MobileLoginForm />
                </TabPanel>

                <TabPanel value="register" dir={theme.direction}>
                  <MobileRegisterForm onSwitchTab={() => setActiveTab("login")} />
                </TabPanel>
              </TabContext>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthTabs;